//SLVI-1334-INICIO
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import Router from './routes';
import './global.scss';
//SLVI-1334-FIX-05 INICIO
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// Interceptor para garantir que X-Url-Origem esteja sempre atualizado antes de cada requisição.
// O valor de urlOrigem no localStorage já está codificado (XOR+Base64) pelo dataConverter,
// portanto deve ser enviado diretamente sem codificação adicional.
axios.interceptors.request.use(function (config) {
  const urlOrigemAtual = localStorage.getItem('urlOrigem');
  if (urlOrigemAtual) {
    config.headers['X-Url-Origem'] = urlOrigemAtual;
  }

  // Log para chamadas ao rollout service
  if (config.url && config.url.toLowerCase().includes('rollout')) {
    console.log('[ROLLOUT SERVICE - CLIENT REQUEST]', {
      url: config.url,
      method: config.method,
      params: config.params,
      data: config.data,
    });
  }

  return config;
});

// Interceptor de resposta para logar retorno do rollout service
axios.interceptors.response.use(
  function (response) {
    if (response.config.url && response.config.url.toLowerCase().includes('rollout')) {
      console.log('[ROLLOUT SERVICE - CLIENT RESPONSE]', {
        url: response.config.url,
        status: response.status,
        data: response.data,
      });
    }
    return response;
  },
  function (error) {
    if (error.config && error.config.url && error.config.url.toLowerCase().includes('rollout')) {
      console.error('[ROLLOUT SERVICE - CLIENT ERROR]', {
        url: error.config.url,
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
    }
    return Promise.reject(error);
  }
);
//SLVI-1334-FIX-05 FIM
//SLVI-1334-FIX-05 FIM

ReactDOM.render(<Router />, document.getElementById('root'));
//SLVI-1334-FIM
